import { mutate } from 'swr';
// logic
import quoteService from '../../quoteService';
// components
import '../../ui/emergencyPopup.css';
import { Modal } from 'react-async-popup';
import RejectQuoteModal from './rejectQuoteModal';

const useRejectQuoteModal = (ticket, quote) => {
  const rejectQuoteModalProps = { ticket, quote };
  const rejectQuoteModal = async () => {
    const { show } = await Modal.new({
      content: (
        <RejectQuoteModal rejectQuoteModalProps={rejectQuoteModalProps} />
      ),
      footer: null,
    });
    const result = await show();
    return result;
  };

  const quoteId = quote?.id;
  const ticketId = ticket?.id;

  const openRejectQuoteModal = async () => {
    const result = await rejectQuoteModal();
    if (result) {
      const feedBackDTO = {
        reasons: [
          {
            category: result.reason,
          },
        ],
      };
      if (result.text.trim().length > 0) feedBackDTO.text = result.text;
      await quoteService.callBackend.rejectQuote({
        quoteId,
        ticketId,
        feedBackDTO,
      });
      // we are mutating the tickets cache so it will reload automatically
      mutate((key) => {
        return typeof key === 'string' && key.startsWith('tickets');
      });
    }
  };

  return {
    openRejectQuoteModal,
  };
};

export default useRejectQuoteModal;
